import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Sprint } from 'types';

const getSprints = async (projectId: string): Promise<Sprint[]> => {
  const response = (await customAxios.get<Sprint[]>(
    `/projects/${projectId}/sprints`
  )) as { data: Sprint[] };
  return response.data;
};

export const useGetSprints = (
  projectId: string | undefined
): UseQueryResult<Sprint[]> =>
  useQuery<Sprint[]>({
    queryKey: ['projects', projectId, 'sprints'],
    queryFn: () => getSprints(projectId as string),
    enabled: Boolean(projectId),
  });
